<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('courses.longrun_title')"></page-header-title>

      <v-spacer></v-spacer>

      <router-link :to="'/f/' + $getSetting('locale') + '/course/upcoming'" class="" target="_blank">
        <action-button type="new" :text="$t('courses.course_list')" :icon="'book'" :icon_only="breakpointSmAndDown" />
      </router-link>

      <v-layout row wrap v-if="$vuetify.breakpoint.smAndUp">
        <v-flex xs12>
          <v-container grid-list-md>
            <v-layout row wrap justify-space-between>
              <v-flex :xs3="$vuetify.breakpoint.smOnly" :xs12="$vuetify.breakpoint.xsOnly">
                <v-text-field
                  :label="$t('global.search')"
                  v-model="search_params.any"
                  @keydown="checkKeyPress"
                  hide-details=""
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex :xs3="$vuetify.breakpoint.smOnly" v-if="$vuetify.breakpoint.smAndUp">
                <v-select
                  v-model="selectedQuickFilter"
                  :items="$dd_course_quick_filter()"
                  item-text="text"
                  item-value="key"
                  :label="$t('courses.quick_filter')"
                  @change="quickFilter"
                  hide-details
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item.text }}</span>
                    <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{ search_params.statuses.length - 1 }} others)</span>
                  </template>
                </v-select>
              </v-flex>
              <v-flex :xs3="$vuetify.breakpoint.smOnly" v-if="$vuetify.breakpoint.smAndUp">
                <v-select
                  v-model="search_params.coursetype_id"
                  :items="coursetypes"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypes.title')"
                  @change="filter"
                  hide-details
                  clearable
                ></v-select>
              </v-flex>
              <v-flex :xs3="$vuetify.breakpoint.smOnly" v-if="$vuetify.breakpoint.smAndUp">
                <v-select
                  v-model="search_params.statuses"
                  :items="$dd_course_status()"
                  item-text="text"
                  item-value="key"
                  :label="$t('courses.status')"
                  @change="filter"
                  hide-details
                  multiple
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item.text }}</span>
                    <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{ search_params.statuses.length - 1 }} others)</span>
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>

      <router-link :to="BACKEND_URL + '/courses/longrun/create'" v-if="$can('course-create')">
        <action-button type="new" :icon_only="breakpointSmAndDown" />
      </router-link>

      <action-button type="filter" @click="show_filter = !show_filter" :icon_only="true" v-if="$vuetify.breakpoint.xsOnly" />
    </v-app-bar>

    <!-- MOBILE SEARCH -->
    <v-expansion-panels :value="0" class="cstm-filter mb-3 elevation-0" v-if="show_filter && $vuetify.breakpoint.xsOnly">
      <v-expansion-panel>
        <v-expansion-panel-content class="elevation-1">
          <v-form ref="form" @submit.prevent="filter">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('global.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    hide-details=""
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="selectedQuickFilter"
                    :items="$dd_course_quick_filter()"
                    item-text="text"
                    item-value="key"
                    :label="$t('courses.quick_filter')"
                    @change="quickFilter"
                    hide-details
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0">{{ item.text }}</span>
                      <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{ search_params.statuses.length - 1 }} others)</span>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="search_params.statuses"
                    :items="$dd_course_status()"
                    item-text="text"
                    item-value="key"
                    :label="$t('courses.status')"
                    @change="filter"
                    hide-details
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0">{{ item.text }}</span>
                      <span v-if="index === 1">, {{ item.text }}</span>
                      <span v-if="index === 2" class="grey--text caption">&nbsp;(+{{ search_params.statuses.length - 2 }} others)</span>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="computedHeaders"
            :items="courses"
            :items-per-page="courses.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.coursetype_id="{ item }">
              {{ item.coursetype.category }}
            </template>

            <template v-slot:item.address="{ item }">
              {{ item.address.city }}
            </template>

            <template v-slot:item.instructor_id="{ item }">
              {{ item.instructor.fullname }}
            </template>

            <template v-slot:item.company_id="{ item }">
              {{ item.company.name }}
            </template>

            <template v-slot:item.start_datetime="{ item }">
              {{ moment.utc(item.start_date).format(DATE_FORMAT) + " " + moment.utc(item.start_time, TIME_FORMAT).format(TIME_FORMAT) }}
            </template>

            <template v-slot:item.end_datetime="{ item }">
              {{ moment.utc(item.end_date).format(DATE_FORMAT) + " " + moment.utc(item.end_time, TIME_FORMAT).format(TIME_FORMAT) }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_course_status(item.status) }}
            </template>

            <template v-slot:item.num_places="{ item }">
              {{ item.num_places }}
              <help-text
                v-if="Boolean(item.num_enrolled > item.num_places)"
                color="#dfa600"
                icon="warning"
                :tooltip="$t('courses.overbooked_tooltip')"
              />
            </template>

            <template v-slot:item.num_enrolled_active_enrolment="{ item }">
              <router-link :to="'/app/enrolments?course_id=' + item.id">
                {{ item.num_enrolled_active_enrolment }}
              </router-link>
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{ path: '/f/no/enrolment/template/' + item.coursetemplate.uuid + '/course/' + item.uuid }"
                v-if="$can('course-access') && item.is_published"
                target="_blank"
                class="hidden-sm-only hidden-xs-only"
              >
                <action-button type="course_reg_form" :icon_only="true" small />
              </router-link>

              <router-link :to="{ path: BACKEND_URL + '/courses/longrun/edit/' + item.id, props: { id: item.id } }">
                <action-button type="edit" small :icon_only="true" />
              </router-link>

              <!--<action-button
                                type="delete"
                                @click="del(item.id)"
                                v-if="$can('course-delete')"
                                class="hidden-sm-only hidden-xs-only"
                                small
                                :icon_only="true"
                            />-->
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "CoursesLongRunList",

  data() {
    return {
      url: "",
      courses: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__courseLongListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["start_datetime"],
        descending: "desc"
      },

      addresses: [],
      coursetypes: [],

      search_params: {
        any: "",
        name: "",
        coursetype_id: "",
        address_id: "",
        statuses: [1], // Upcoming
        instructor_id: ""
      },
      selectedQuickFilter: "my-courses"
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__courseLongRunListSearchParams", JSON.stringify(this.search_params))
          localStorage.setItem("__courseLongRunListQuickFilter", this.selectedQuickFilter)
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__courseLongListPage", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "courses"
    if (localStorage.getItem("__courseLongRunListSearchParams")) {
      this.search_params = JSON.parse(localStorage.getItem("__courseLongRunListSearchParams"))

      // For new search params variable
      this.search_params.coursetemplate_type = 2 // Long run course
    }
    if (localStorage.getItem("__courseLongRunListQuickFilter")) {
      this.selectedQuickFilter = localStorage.getItem("__courseLongRunListQuickFilter")
    }
  },

  computed: {
    breakpointSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown
    },
    computedHeaders() {
      let headers = [
        { text: this.$t("courses.id"), value: "id" },
        { text: this.$t("courses.name"), value: "name" },
        { text: this.$t("coursetypes.short_title"), value: "coursetype_id", hide: "mdAndDown" },
        { text: this.$t("courses.location"), value: "address", hide: "mdAndDown" },
        { text: this.$t("courses.instructor_id"), value: "instructor_id" },
        { text: this.$t("enrolments.o_name"), value: "company_id" },
        { text: this.$t("courses.num_enrolled_attendees"), value: "num_enrolled_attendees", sortable: false, width: "10%" },
        { text: this.$t("courses.status"), value: "status", width: "10%" },
        { text: this.$t("global.actions"), value: "actions", width: "10%", align: "end", sortable: false }
      ]

      return headers.filter((h) => !h.hide || !this.$vuetify.breakpoint[h.hide])
    }
  },

  methods: {
    list() {
      this.show_loading = true
      this.quickFilter()

      var params = JSON.parse(JSON.stringify(this.search_params))

      if (params.statuses) {
        params.statuses = params.statuses.join(",")
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      params.coursetype_status = 1
      let query = this.$queryString(this.pagination, params)

      axios.get(this.url + "?resourcetype=course-basic-list&" + query).then((res) => {
        this.courses = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })

      this.loadDropdown()
    },

    loadDropdown() {
      let lists = [
        { key: "addresses", module: "addresses", query: "show_all=true" },
        { key: "coursetypes", module: "coursetypes", query: "show_all=true&query_status=1" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.addresses = res.data.addresses
        this.coursetypes = res.data.coursetypes
      })
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
    },

    quickFilter(target) {
      let user = this.$store.getters["auth/user"]

      switch (this.selectedQuickFilter) {
        case "my-courses":
          this.search_params.instructor_id = user.id
          break
        case "unassigned":
          this.search_params.instructor_id = "null"
          break
        case "company-internal":
          this.search_params.company_id = "not-null"
          break
        case "all":
          this.search_params.instructor_id = ""
          break
      }

      localStorage.setItem("__courseQuickFilter", this.selectedQuickFilter || "")
      this.filter()
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "course/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
